'use client';

import { useEffect, useState } from 'react';
import { useT } from '@/i18n/client';
import { isSoundMuted, playTap, toggleSoundMuted } from '@/lib/sound';

/** A small mute/unmute button for the learning games. */
export function SoundToggle({ className }: { className?: string }) {
  const t = useT();
  const [muted, setMuted] = useState(false);

  // Read the persisted preference after mount (localStorage is client-only).
  useEffect(() => {
    setMuted(isSoundMuted());
  }, []);

  function toggle() {
    const next = toggleSoundMuted();
    setMuted(next);
    if (!next) playTap(); // give immediate audible confirmation when turning on
  }

  return (
    <button
      type="button"
      className={`vn-sound-toggle${className ? ` ${className}` : ''}`}
      aria-pressed={!muted}
      aria-label={muted ? t('games.soundOff') : t('games.soundOn')}
      title={muted ? t('games.soundOff') : t('games.soundOn')}
      onClick={toggle}
    >
      <span aria-hidden="true">{muted ? '🔇' : '🔊'}</span>
    </button>
  );
}
